<template>
  <div>
    <h5>Tipo de pedido</h5>
    <div class="flex pt-2" style="justify-content: space-evenly;">
      <vs-radio v-for="item in Object.values(types)" :key="item.value"
        v-model="deliveryType" :vs-value="item.value">{{ item.description }}</vs-radio><br/>
    </div>
    <div>
      <vs-divider class=" mt-base mb-base"> <feather-icon class="mr-1" icon="MapPinIcon" svgClasses="h-4 w-4 "></feather-icon> ENDEREÇO <feather-icon class="ml-1" icon="MapPinIcon" svgClasses="h-4 w-4 "></feather-icon> </vs-divider>
      
      <a-alert v-if="isInRange === false && isCompletedAddress && isDelivery"
        message="Área fora de cobertura"
        banner
      />
      <address-form v-model="address" :disabled="!isDelivery" :class="{ 'disabled': !isDelivery }"/>

      <div class="sm:w-full md:w-1/2 lg:w-1/2 xl:w-4/12 mb-4" :class="{ 'disabled': !isDelivery }">
          <label class="ml-1">Complemento</label>
          <a-textarea v-model="address.complemento"
            :disabled="!isDelivery"
            class="mt-2"
            :auto-size="{ minRows: 3, maxRows: 5 }"/>
      </div>
      
    </div>

  </div>
</template>

<script>
  import axios from 'axios';
  import { geoToH3 } from 'h3-js';
  import { mapState, mapMutations } from 'vuex';
  import AddressForm from '@/components/shared/AddressForm';
  
  async function byNominatim (address) {
    const result = await axios.get(`https://nominatim.openstreetmap.org/search?q=${encodeURI(address)}&format=json`);
    if (!result.data.length)
      return null;
    const data = result.data[0];
    return { lat: data.lat, lng: data.lon, };
  }

  async function byGoogle (address) {
    const result = await axios.get(`https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURI(address)}&key=AIzaSyCw5p3lqP2jDehS8rhXhn_ZkYJFFh3OI1k`);
    return result.data.results.length ? result.data.results[0].geometry.location : null;
  }

  async function getH3FromAddress (address) {
    const firstResult = await byNominatim(address) || await byGoogle(address);
    return geoToH3(firstResult.lat, firstResult.lng, 8);
  }

  export default {
    components: {
      AddressForm
    },
    watch: {
      address: {
        handler (val) {
          this.setAddress(Object.assign({}, val));
          this.checkIfInsideRange();
          this.$emit('valid', this.isValid);
        },
        immediate : true,
        deep: true
      },
      deliveryType () {
        this.$emit('valid', this.isValid);
      }
    },
    data() {
      return {
        types: {
          delivery: { value: 'delivery', description: 'Delivery' },
          takeaway: { value: 'takeaway', description: 'Retirada' },
        },
        address: {
          logradouro : '',
          bairro : '',
          numero : '',
          municipio : '',
          uf : 'ES',
          cep : '',
          complemento: ''
        },
        isInRange: null
      }
    },
    computed: {
      deliveryType: {
        get () {
          return this.isDelivery ?
            this.types.delivery.value :
            this.types.takeaway.value;
        },
        set (v) {
          this.setIsDelivery(v === this.types.delivery.value);
          this.$emit('changeType', this.types[v].description);
        }
      },
      isDelivery () {
        return this.deliveryType == 'delivery';
      },
      isCompletedAddress () {
        return !!(this.address.logradouro.length && this.address.bairro.length && this.address.municipio.length)
      },
      isValid () {
        return !this.isDelivery 
          || !!(this.address.logradouro.length && this.address.bairro.length && this.address.municipio.length);
      },
      ...mapState('delivery', ['deliveryAddress', 'isDelivery']),
      ...mapState(['AppActiveCompany'])
    },
    methods: {
      async checkIfInsideRange () {
        const { address } = this;
        if (!this.isCompletedAddress) {
          return;
        }
        const boundaries = this.AppActiveCompany.deliveryConfig.allowedBoundary;
        const completeAddress = `${address.logradouro} ${address.bairro} ${address.municipio} ${address.uf}`;
        if (this.timeout)
          clearInterval(this.timeout);
        this.timeout = setTimeout(async () => {
          const h3 = await getH3FromAddress(completeAddress);
          this.isInRange = !!boundaries.find(b => b === h3);
        }, 500);
      },
      ...mapMutations('delivery', ['setAddress', 'setIsDelivery'])
    },
    mounted () {
      this.deliveryType = 'delivery'
    }
  }
</script>

<style lang="scss" scoped>
  .disabled {
    opacity: 0.5;
  }
</style>